export default __webpack_public_path__ + "static/media/cellarTech.7569bd9e.png";